<layout-default>
    <div header>
        <div toolbar>
            <h4>
                <i-feather name="clock"></i-feather> 
                <span *ngIf="regionId"> {{'Timeslots for region' | translate}}</span>
                <span *ngIf="!regionId"> {{'Timeslots for partner' | translate}}</span>
            </h4>
        </div>

        <div toolbar>
            <button id="timeslots-btn-create" class="btn btn-sm btn-uppercase btn-white"
                [routerLink]="['../create']">
                <i-feather [style.height.px]="23" [style.width.px]="13" class="mg-r-10" name="plus"></i-feather> {{ 'Add timeslot' | translate }}
            </button>
            <div id="timeslots-btn-search" class="filter-container">
                <div class="phrase-filter">
                    <input type='text' class="list-filter form-control" placeholder="{{'type to search' | translate}}" (keyup)='applyFiltering($event)'/>
                </div>
            </div>
        </div>
        <hr />
    </div>
    
    <div content>
        <div *ngIf="!loader">
            <ngx-datatable 
                id="timeslots-table" 
                class="bootstrap" 
                [rows]="timeslots" 
                [columns]="columns" 
                [columnMode]="'flex'"
                [headerHeight]="50" 
                [footerHeight]="50" 
                [messages]="tableMessages" 
                [rowHeight]="'auto'" 
                [rowClass]="rowClass"
                [limit]="size" 
                [scrollbarH]="scrollBarHorizontal">
                <ng-container *ngFor="let col of columns">
                    <ngx-datatable-column [flexGrow]="col.flexGrow" [prop]="col.prop">
                        <ng-template let-column="column" ngx-datatable-header-template class="header" let-sort="sortFn">
                            <b>{{ col.name | translate }}</b>
                        </ng-template>
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                            <ng-container [ngSwitch]="col.prop">
                                <div *ngSwitchCase="'options'">
                                    <div class="dropdown" dropdown>
                                        <button
                                            class="btn btn-outline-secondary btn-xs dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton">
                                            {{ 'Select' | translate }}
                                        </button>
    
                                        <div class="dropdown-menu dropdown-menu-right div-main-actions">
    
                                            <a 
                                                id="timeslots-btn-edit"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                [routerLink]="['../edit', row.id]">
                                                    {{'Edit' | translate }}
                                            </a>
    
                                            <a 
                                                id="timeslots-btn-configuration"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                (click)="goToConfig(row)">
                                                    {{'Show configuration' | translate }}
                                            </a>
    
                                            <a 
                                                id="timeslots-btn-remove"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                (click)="removeTimeslot(row.id)">
                                                    {{'Remove' | translate }}
                                            </a>
    
                                        </div>
                                    </div>
                                </div>
                                
                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'timeslot'">
                                    {{ value | timeWindowPipe }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'pickupSlot'">
                                    {{ value | timeWindowPipe }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'customerTimeWindow'">
                                    {{ value | timeWindowPipe }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'putInTimeWindow'">
                                    {{ value | timeWindowPipe }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'purgeTimeWindow'">
                                    {{ value | timeWindowPipe }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'ownLogisticCancelTime'">
                                    {{ value.slice(0, 5) }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'ownLogisticCutoff'">
                                    {{ value.slice(0, 5) }}
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchCase="'active'">
                                    <ng-container [ngSwitch]="value">
                                        <span *ngSwitchCase="true" class="badge badge-success">{{ 'ACTIVE' | translate }}</span>
                                        <span *ngSwitchCase="false" class="badge badge-danger">{{ 'INACTIVE' | translate }}</span>
                                    </ng-container>
                                </div>

                                <div id="timeslots-table-col-{{col.prop}}" *ngSwitchDefault>
                                    {{ value | translate }}
                                </div>

                            </ng-container>
                      
                        </ng-template>
                    </ngx-datatable-column>
                </ng-container>
            </ngx-datatable>
        </div>

        <div *ngIf="loader" class="load-spinner text-center">
            <i class="fa fa-spinner fast-pulse" aria-hidden="true"></i> {{ 'Please, wait!' | translate }}
        </div>

    </div>

</layout-default>

<ng-template #confirmation>
    <div class="modal-header">
        <h4 class="modal-title">{{'Confirm action' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="decline()"><span aria-hidden="true">&times;</span></button>
    </div>

    <div class="modal-body text-center">
        <p>{{'Do you confirm removal of the timeslot' | translate }}?</p>
        <button type="button" class="btn btn-brand-01" (click)="confirm()">
            {{'Yes, remove' | translate }}
        </button>
        <button type="button" class="btn btn-default" (click)="decline()">{{'Cancel' | translate }}</button>
    </div>
</ng-template>
